export const clientId = process.env.REACT_APP_OKTA_CLIENT_ID;